import { schema } from "normalizr"

export default new schema.Entity(
  "resourceDetails",
  {},
  {
    idAttribute: "resourceId",
  }
)
